/* Höstkampanj: val av servicepaket och inlämningsdag, sedan direkt till kassan. */
(function () {
  var el = document.getElementById('hk-data');
  if (!el) return;
  var data = JSON.parse(el.textContent);
  var YEAR = 2026, MONTH = 9; // oktober

  var dayNames = ['söndag', 'måndag', 'tisdag', 'onsdag', 'torsdag', 'fredag', 'lördag'];
  var monthNames = ['januari', 'februari', 'mars', 'april', 'maj', 'juni', 'juli', 'augusti', 'september', 'oktober', 'november', 'december'];
  var kr = function (ore) {
    var n = ore / 100;
    return n.toLocaleString('sv-SE', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }) + ' kr';
  };
  var fmt = function (d) { return dayNames[d.getDay()] + ' ' + d.getDate() + ' ' + monthNames[d.getMonth()]; };
  var short = function (d) { return dayNames[d.getDay()].slice(0, 3) + ' ' + d.getDate() + ' okt'; };
  var addDays = function (d, n) { var r = new Date(d); r.setDate(r.getDate() + n); return r; };
  var hours = function (d) { var w = d.getDay(); return (w === 0 || w === 6) ? 'Mellan 11 och 16.' : 'Mellan 10 och 18.'; };

  var state = { pkg: null, day: null };

  // Servicepaket
  var pkgs = document.getElementById('pkgs');
  if (!data.packages.length) {
    var e = document.createElement('p');
    e.className = 'empty';
    e.textContent = 'Servicepaketen är inte upplagda än.';
    pkgs.appendChild(e);
  }
  data.packages.forEach(function (p) {
    var l = document.createElement('label');
    l.className = 'pkg';
    l.innerHTML = '<input type="radio" name="pkg" id="pkg-' + p.id + '" value="' + p.id + '">' +
      '<span class="name"></span><span class="price">' +
      (p.compareAt > p.price ? '<s>' + kr(p.compareAt) + '</s>' : '') + '<b>' + kr(p.price) + '</b></span>' +
      '<span class="desc"></span>';
    l.querySelector('.name').textContent = p.name;
    l.querySelector('.desc').textContent = p.desc;
    l.querySelector('input').addEventListener('change', function () { state.pkg = p; update(); });
    pkgs.appendChild(l);
  });

  // Kalender
  var byDate = {};
  data.days.forEach(function (d) { byDate[d.date] = d; });
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  var grid = document.getElementById('grid');
  ['mån', 'tis', 'ons', 'tor', 'fre', 'lör', 'sön'].forEach(function (d) {
    var e = document.createElement('div'); e.className = 'dow'; e.textContent = d; grid.appendChild(e);
  });
  var lead = (new Date(YEAR, MONTH, 1).getDay() + 6) % 7;
  for (var i = 0; i < lead; i++) { var b = document.createElement('div'); b.className = 'blank'; grid.appendChild(b); }
  var today = new Date(); today.setHours(0, 0, 0, 0);
  var last = new Date(YEAR, MONTH + 1, 0).getDate();
  var buttons = [];
  for (var n = 1; n <= last; n++) {
    (function (n) {
      var d = new Date(YEAR, MONTH, n);
      var slot = byDate[YEAR + '-' + pad(MONTH + 1) + '-' + pad(n)];
      var closed = !slot || d < today;
      var full = !closed && slot.left <= 0;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'day';
      btn.setAttribute('aria-pressed', 'false');
      btn.innerHTML = n + (closed ? '' : '<small>' + (full ? 'fullt' : slot.left + ' kvar') + '</small>');
      btn.setAttribute('aria-label', fmt(d) + (closed ? ', stängt för inlämning' : full ? ', fullbokad' : ', ' + slot.left + ' platser kvar'));
      if (closed || full) { btn.disabled = true; if (full) btn.classList.add('full'); }
      btn.addEventListener('click', function () {
        buttons.forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        state.day = { date: d, slot: slot };
        update();
      });
      buttons.push(btn);
      grid.appendChild(btn);
    })(n);
  }

  var pickup = document.getElementById('pickup');
  var sum = document.getElementById('sum');
  var pay = document.getElementById('pay');
  var err = document.getElementById('err');

  // Kassaraden döljs medan första skärmen syns, så att den inte konkurrerar med knappen där.
  var bar = document.getElementById('bar');
  var hero = document.getElementById('hero');
  var heroVisible = true;
  function syncBar() { bar.classList.toggle('away', heroVisible && !state.pkg && !state.day); }
  if (hero && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (e) { heroVisible = e[0].intersectionRatio > 0.4; syncBar(); }, { threshold: [0, 0.4, 1] }).observe(hero);
  } else {
    heroVisible = false; syncBar();
  }

  function ready() { return addDays(state.day.date, data.readyAfter); }

  function update() {
    if (state.day) {
      pickup.hidden = false;
      document.getElementById('pickupDate').textContent = fmt(ready());
      document.getElementById('pickupHours').textContent = hours(ready()) + ' Vi hör av oss om något ändras.';
    }
    sum.innerHTML = '';
    var b = document.createElement('b');
    var s = document.createElement('span'); s.className = 'muted';
    if (state.pkg && state.day) {
      b.textContent = state.pkg.name + ' · ' + kr(state.pkg.price);
      s.textContent = 'Lämnas in ' + short(state.day.date);
    } else {
      b.textContent = state.pkg ? 'Välj dag att lämna in' : state.day ? 'Välj service' : 'Välj service och dag';
      s.textContent = state.pkg ? state.pkg.name : state.day ? 'Lämnas in ' + short(state.day.date) : '10 % rabatt i oktober';
    }
    sum.appendChild(b); sum.appendChild(s);
    pay.disabled = !(state.pkg && state.day);
    err.hidden = true;
    syncBar();
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      if (!r.ok) return r.json().catch(function () { return {}; }).then(function (j) { throw j; });
      return r.json();
    });
  }

  pay.addEventListener('click', function () {
    if (!(state.pkg && state.day)) return;
    pay.disabled = true;
    pay.setAttribute('aria-busy', 'true');
    pay.textContent = 'Går till kassan…';
    var dropoff = fmt(state.day.date);
    post('/cart/clear.js')
      .then(function () {
        return post('/cart/add.js', {
          items: [
            { id: state.pkg.id, quantity: 1, properties: { 'Inlämning': dropoff, 'Klar att hämta': fmt(ready()) } },
            { id: state.day.slot.id, quantity: 1 }
          ]
        });
      })
      .then(function () { window.location.href = '/checkout'; })
      .catch(function (e) {
        pay.removeAttribute('aria-busy');
        pay.textContent = 'Betala och boka';
        pay.disabled = false;
        err.hidden = false;
        err.textContent = (e && e.status === 422)
          ? 'Den dagen blev precis fullbokad. Välj en annan dag.'
          : 'Något gick fel. Försök igen om en stund.';
      });
  });
})();
